// mock.ts
import { BasicConfigurationModel } from './types'

export const basicConfigurationMock: BasicConfigurationModel = {
  name: 'TechNova Solutions Sp. z o.o.',
  legalStatus: 'Spółka z ograniczoną odpowiedzialnością',
  street: 'ul. Polna',
  buildingNumber: '15A',
  flatNumber: '3',
  city: 'Warszawa',
  postalCode: '00-950',
  post: 'Warszawa',
  country: {
    code: 'PL',
    name: 'Polska',
    id: 1,
    nationId: 1,
  },
  nip: '5252654321',
  regon: '385123456',
  krs: '0000854321',
  officePhone: '+48 22 654 32 10',
  mobile: '+48 600 123 456',
  fax: '+48 22 654 32 11',
  email: 'kontakt@technova.pl',
  www: 'https://www.technova.pl',
  contactPerson: 'Marta Nowak',
  position: 'Dyrektor operacyjny',
  licenseNumber: 'LIC-2025-PL-001',

  // --- Deprecated fields (still mocked for legacy compatibility) ---
  address: 'ul. Polna 15A/3, 00-950 Warszawa, Polska',
};
